import { UserProvider } from "../../contexts/user.context";

import Navigation from "../../components/navigation/navigation.component";
import { Outlet } from "react-router";
import { CategoriesProvider } from "../../contexts/categories.context";
import { CartProvider } from "../../contexts/cart.context";

const StoreLayout = () => (
  <>
    <UserProvider>
      <CategoriesProvider>
        <CartProvider>
          <Navigation />
          <Outlet />
        </CartProvider>
      </CategoriesProvider>
    </UserProvider>
  </>
);

export default StoreLayout;